import { Controller } from "@hotwired/stimulus"

/**
 * Modal Reset Controller
 *
 * Resets content inside a dialog when it closes.
 * Stores the original HTML on connect and restores it when the dialog closes.
 *
 * Usage:
 *   <dialog data-controller="modal-reset"
 *           data-modal-reset-target-value="turbo_frame_id">
 */
export default class extends Controller<HTMLDialogElement> {
  static values = {
    target: String
  }

  declare targetValue: string

  private originalContent: string = ""
  private boundHandleClose: () => void

  constructor(context: any) {
    super(context)
    this.boundHandleClose = this.handleClose.bind(this)
  }

  connect(): void {
    const target = document.getElementById(this.targetValue)
    if (target) {
      this.originalContent = target.innerHTML
    }

    this.element.addEventListener("close", this.boundHandleClose)
  }

  disconnect(): void {
    this.element.removeEventListener("close", this.boundHandleClose)
  }

  private handleClose(): void {
    const target = document.getElementById(this.targetValue)

    if (target && this.originalContent) {
      target.innerHTML = this.originalContent
    }
  }
}
